import { isMobileOrTablet } from "Utils/DeviceDetectHelpers";

export default store => ({
  path: "teacher",
  onEnter: (nextState, replace) => {
    const queryString = nextState.location.search || "";

    // Get sub-path after /teacher
    const splat = nextState.params.splat || "";
    if (isMobileOrTablet()) {
      replace(`/app-download/teacher/${splat}${queryString}`);
    } else {
      replace(`/${splat}${queryString}`);
    }
  },
});
